export default "__VITE_ASSET__CcLMMUty__"